import http, { getBase } from '../http'

const API_URL = 'company-branding'

class BrandingAPI {
  async show(companyId) {
    return await http(`${API_URL}/${companyId}`)
  }

  async upsert(companyId, payload) {
    return await http(`${API_URL}/${companyId}`, 'PUT', payload)
  }

  async syncSso(companyId, payload) {
    return await http(`${API_URL}/${companyId}/sync-sso`, 'POST', payload)
  }

  async uploadLogo(companyId, file) {
    const fd = new FormData()
    fd.append('logo', file)
    const res = await fetch(`${getBase()}${API_URL}/${companyId}/logo`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    })
    return res.json()
  }
}

export default new BrandingAPI()
